import { currentEphemeralEnv, ephemeralOriginFor } from './ephemeral';

export const ACCOUNT = 'account';
export const WALLET = 'wallet';
export const SHOP = 'shop';

export const ACTIVE = 'ACTIVE';
export const EXPIRED = 'EXPIRED';
export const INACTIVE = 'INACTIVE';

let base_domain,
  domain,
  idme_url,
  rx_url,
  shop_url,
  idp_url,
  ga4,
  sentry_whitelist,
  sentry_dsn;
let terms_url = 'https://www.id.me/terms';

const hostnameToEnv = {
  'wallet.id.me': 'production',
  'account.id.me': 'production',
  'wallet.idme.cc': 'staging',
  'account.idme.cc': 'staging',
  'wallet.idmelabs.com': 'labs',
  'account.idmelabs.com': 'labs',
  'wallet.idmelabs.co': 'internal-labs',
  'wallet.idme.co': 'internal-production',
  'account.idme.co': 'internal-production',
  'wallet.idme.dev': 'dev',
  'account.idme.dev': 'dev',
};

export const getReactEnv = () => {
  return hostnameToEnv[window.location.hostname] || 'development';
};

const ACCOUNT_SENTRY_DSN =
  'https://98241fdf8594450a8bf15e2e3ee09a32@sentry.io/1313106';
const WALLET_SENTRY_DSN =
  'https://d313433ddae47a2aeef5038542e5b11d@o52232.ingest.us.sentry.io/4511134404182016';

const isWallet = window.location.hostname.startsWith('wallet');

switch (getReactEnv()) {
  case 'dev':
    base_domain = 'idme.dev';
    domain = isWallet ? 'https://wallet.idme.dev' : 'https://account.idme.dev';
    idme_url = 'https://homepage.idme.dev';
    rx_url = 'https://rx.idme.dev';
    shop_url = 'https://shop.idme.dev';
    idp_url = 'https://api.idme.dev';
    ga4 = 'GTM-PL62HD9';
    sentry_whitelist = isWallet ? [/wallet.idme.dev/] : [/account.idme.dev/];
    sentry_dsn = isWallet ? WALLET_SENTRY_DSN : ACCOUNT_SENTRY_DSN;
    break;
  case 'staging':
    base_domain = 'idme.cc';
    domain = isWallet ? 'https://wallet.idme.cc' : 'https://account.idme.cc';
    idme_url = 'https://homepage.idme.cc';
    rx_url = 'https://rx.idme.cc';
    shop_url = 'https://shop.idme.cc';
    idp_url = 'https://api.idme.cc';
    ga4 = 'GTM-PL62HD9';
    sentry_whitelist = isWallet ? [/wallet.idme.cc/] : [/account.idme.cc/];
    sentry_dsn = isWallet ? WALLET_SENTRY_DSN : ACCOUNT_SENTRY_DSN;
    break;
  case 'labs':
    base_domain = 'idmelabs.com';
    domain = isWallet
      ? 'https://wallet.idmelabs.com'
      : 'https://account.idmelabs.com';
    idme_url = 'https://homepage.idmelabs.com';
    rx_url = 'https://rx.id.me'; // There is no rx sandbox
    shop_url = 'https://shop.id.me'; // There is no shop sandbox
    terms_url = 'https://developers.idmelabs.com/developer-terms';
    idp_url = 'https://api.idmelabs.com';
    ga4 = 'GTM-PWDJ5SM';
    sentry_whitelist = isWallet
      ? [/wallet.idmelabs.com/]
      : [/account.idmelabs.com/];
    sentry_dsn = isWallet ? WALLET_SENTRY_DSN : ACCOUNT_SENTRY_DSN;
    break;
  case 'internal-labs':
    base_domain = 'idmelabs.co';
    domain = 'https://wallet.idmelabs.co';
    idme_url = 'https://homepage.idmelabs.co';
    rx_url = 'https://rx.id.me'; // There is no rx sandbox
    shop_url = 'https://shop.id.me'; // There is no shop sandbox
    terms_url = 'https://developers.idmelabs.co/developer-terms';
    idp_url = 'https://api.idmelabs.co';
    ga4 = 'GTM-PWDJ5SM';
    sentry_whitelist = [/wallet.idmelabs.co/];
    sentry_dsn = WALLET_SENTRY_DSN;
    break;
  case 'internal-production':
    base_domain = 'idme.co';
    domain = isWallet ? 'https://wallet.idme.co' : 'https://account.idme.co';
    idme_url = 'https://idme.co';
    rx_url = 'https://rx.idme.co';
    shop_url = 'https://shop.idme.co';
    idp_url = 'https://api.idme.co';
    ga4 = 'GTM-PL62HD9';
    sentry_whitelist = isWallet ? [/wallet.idme.co/] : [/account.idme.co/];
    sentry_dsn = isWallet ? WALLET_SENTRY_DSN : ACCOUNT_SENTRY_DSN;
    break;
  case 'production':
    base_domain = 'id.me';
    domain = isWallet ? 'https://wallet.id.me' : 'https://account.id.me';
    idme_url = 'https://id.me';
    rx_url = 'https://rx.id.me';
    shop_url = 'https://shop.id.me';
    idp_url = 'https://api.id.me';
    ga4 = 'GTM-PL62HD9';
    sentry_whitelist = isWallet ? [/wallet.id.me/] : [/account.id.me/];
    sentry_dsn = isWallet ? WALLET_SENTRY_DSN : ACCOUNT_SENTRY_DSN;
    break;
  default: {
    // this is development -- which is also every ephemeral ("mini-me") environment,
    // because those hostnames are not in hostnameToEnv and never will be: they are
    // created on demand and adding one per environment is exactly the per-env
    // control-plane write the whole design exists to avoid.
    //
    // Derive the sibling service URLs from the CURRENT hostname when we are in one.
    // Falling through to the hardcoded flat names below would send this environment's
    // API calls to whichever namespace the shared terminator designates as primary --
    // i.e. a different tester's environment, silently and with no error.
    const ee = currentEphemeralEnv();

    base_domain = ee ? ee.domain : 'idme.test';
    domain = '*';
    idp_url = ee ? ephemeralOriginFor('api', ee) : 'https://api.idme.test';
    // Not routed by the ephemeral terminator (it serves only api/enroll/wallet/
    // wallet-api), so these stay on the flat local names rather than pretending a
    // per-environment homepage/rx/shop exists.
    idme_url = 'https://homepage.idme.test';
    rx_url = 'https://rx.idme.test';
    shop_url = 'https://shop.idme.test';
    // Sentry and GA4 are not enabled in development
    ga4 = null;
    sentry_whitelist = null;
    break;
  }
}

// domain for postMessage
export const BASE_DOMAIN = base_domain;
export const DOMAIN = domain;
export const IDME_URL = idme_url;
export const RX_URL = rx_url;
export const SHOP_URL = shop_url;
export const TERMS_URL = terms_url;
export const IDP_URL = idp_url;

// Production URLs everywhere, like the legacy footer: other environments' legal pages are stale.
export const FOOTER_URLS = {
  home: 'https://id.me',
  accessibility: 'https://www.id.me/accessibility',
  privacy: 'https://www.id.me/privacy',
  washingtonPrivacy: 'https://www.id.me/washington-privacy',
  biometrics: 'https://www.id.me/biometric',
};

export const SOCIAL_URLS = {
  x: 'https://x.com/IDme',
  facebook: 'https://www.facebook.com/IDmeInc',
  linkedin: 'https://www.linkedin.com/company/id.me',
  instagram: 'https://www.instagram.com/id.me/',
};

export const GA4_TRACKING_ID = ga4;
export const SENTRY_ENABLED = !!sentry_whitelist;
export const SENTRY_WHITELIST = sentry_whitelist;
export const SENTRY_DSN = sentry_dsn;

export const EXISTS = 'exists';
export const PENDING = 'pending';

export const BIOMETRIC_CONSENT = 'biometric_consent';

// localStorage key for the cached fragno1 flag (fragno1/loadFragno1Flag.js).
export const FLAG_CACHE_KEY = 'fragno1_known';

export const SELFIE_DELETE = 'selfie';

// TODO: remove this flag after translations are fully baked out
export const TRANSLATIONS_SUPPORTED = false;

// smartystreets
export const SMARTYSTREETS_KEY = '34189370593289257';

export const LINETYPES = [
  { label: 'Mobile', value: 'mobile' },
  { label: 'Office', value: 'office' },
  { label: 'Home', value: 'home' },
  { label: 'Other', value: 'other' },
];

export const WORK = 'work';
export const PERSONAL = 'personal';

// TODO (fast-follow): source the payout threshold from the /api/cashback payload (SHOPWEB-693 follow-up)
export const CASHBACK_PAYOUT_THRESHOLD = 10; // USD, major units
